import { Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import z from 'zod';
import ZaraButton from '../../components/custom-components/buttons/Button';
import { useForm } from 'react-hook-form';
import { emailSchema, passwordSchema } from '../../utils/schemas';
import { PATHS } from '../../router/routes';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../provider';
import FormInput from '../../components/custom-components/Inputs/FormInput';
import { INPUT_PROPS } from '../../utils/constants';
import SocialButtons from '../../components/custom-components/buttons/SocialButtons';

const schema = z.object({
    email: emailSchema,
    password: passwordSchema,
});

const SignIn = () => {
    const { signIn, loading, setLoading } = useAuth();

    const router = useNavigate();

    const location = useLocation();
    const { pathname } = location;

    const { control, handleSubmit } = useForm({
        defaultValues: {
            email: '',
            password: '',
        },
        mode: 'onSubmit',
        resolver: zodResolver(schema),
    });

    const [hideNewPass, setHideNewPass] = useState(true);

    useEffect(() => {
        const matchingSub = ['app.dialzara.com', 'dev-app.dialzara.com'].find(sub => window.location.host.includes(sub));
        if (matchingSub) {
            const currentPath = window.location.pathname + window.location.search;
            if (window.location.host === 'dev-app.dialzara.com') {
                window.location.href = 'https://dev-preview.dialzara.com' + currentPath;
                return;
            }
            else if (window.location.host === 'app.dialzara.com') {
                window.location.href = 'https://web.dialzara.com' + currentPath;
                return;
            }
        }
    }, []);

    async function onSubmit(data) {
        const variables = {
            email: data.email.toLowerCase(),
            password: data.password,
            isSignInPage: true,
        };

        await signIn(variables);
    }

    useEffect(() => {
        setLoading(false);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    return (
        <div className='min-h-screen bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center p-4'>
            <div className='w-full max-w-md space-y-8 bg-white p-6 rounded-xl shadow-2xl'>
                <div className='text-center'>
                    <h2 className='mt-6 text-3xl font-bold text-gray-900'>Welcome Back</h2>
                    <p className='mt-2 text-sm text-gray-600'>Please enter your details to log in to Dialzara</p>
                </div>
                <form className='mt-8 space-y-6' onSubmit={handleSubmit(onSubmit)}>
                    <div className='space-y-6 rounded-md shadow-sm'>
                        <FormInput
                            control={control}
                            controllName={INPUT_PROPS.EMAIL.CONTROLL_NAME}
                            placeholder={INPUT_PROPS.EMAIL.PLACEHOLDER}
                        />
                        <FormInput
                            variant='password'
                            control={control}
                            controllName={INPUT_PROPS.PASSWORD.CONTROLL_NAME}
                            placeholder={INPUT_PROPS.PASSWORD.PLACEHOLDER}
                            hidePass={hideNewPass}
                            setHidePass={setHideNewPass}
                        />
                        <ZaraButton isLoading={loading} w='100%' type='submit' isDisabled={loading}>
                            Log In
                        </ZaraButton>
                    </div>
                </form>

                <div className='mt-6'>
                    <div className='relative'>
                        <div className='absolute inset-0 flex items-center'>
                            <div className='w-full border-t border-gray-300' />
                        </div>
                        <div className='relative flex justify-center text-sm'>
                            <span className='px-2 bg-white text-gray-500'>Or continue with</span>
                        </div>
                    </div>

                    <SocialButtons type='row' />
                </div>

                <div className='text-sm text-center'>
                    <Text
                        cursor='pointer'
                        _hover={{
                            textDecoration: 'underline',
                        }}
                        color='#4f46e5'
                        onClick={() => router(PATHS.FORGOT_PASSWORD)}
                    >
                        Forgot your password?
                    </Text>
                </div>

                <div className='text-sm text-center text-gray-600'>
                    Don't have an account?{' '}
                    <Text
                        as='span'
                        cursor='pointer'
                        _hover={{
                            textDecoration: 'underline',
                        }}
                        ml='1'
                        h
                        color='#4f46e5'
                        onClick={() => router(PATHS.SIGN_UP)}
                    >
                        Sign Up
                    </Text>
                </div>
            </div>
        </div>
    );
};

export default SignIn;
